import { NavigateFunction } from 'react-router-dom';

type BuildEnv = 'er' | 'wa' | 'wf' | 'all' | undefined;
const env = process.env.REACT_APP_BUILD_NAME as BuildEnv;

export const WARDS_ROOT = env === 'wa' ? '' : '/wa';

export const buildWardsPath = (path: string) => {
  if (!WARDS_ROOT) return path.startsWith('/') ? path : `/${path}`;

  if (path === WARDS_ROOT || path.startsWith(`${WARDS_ROOT}/`)) return path;

  return `${WARDS_ROOT}${path.startsWith('/') ? path : `/${path}`}`;
};

export const wardsNavigate = (navigate: NavigateFunction, path: string, replace: boolean = false) =>
  navigate(buildWardsPath(path), { replace: replace });
